// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./newFeePlan.css";
// import "../CreateQuestionsPaper/TestScheduling/testscheduling.css";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../Components/Shared/Dropdown/Dropdown";
// import SearchDropdown from "../../Components/SearchDropdownforListDataSingleSelect/SearchdropdownforlistdataSingleSelect";
// import EndPoints from "../../Api/EndPoints";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../Assets/Images/CommanImages/Informative.png";
// import MinusImg from "../../Assets/Images/CommanImages/MinusGrey.png";
// import YellowPlus from "../../Assets/Images/CommanImages/YellowPlus.png";

// // ---------------------------------------------------------------------------
// // Helpers
// // ---------------------------------------------------------------------------

// const makeInstallment = (installment_no) => ({
//   key: `inst_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
//   installment_no,
//   due_date: "",
//   amount: "",
//   remarks: "",
// });

// const DEFAULT_INSTALLMENT_COUNT = 3;

// const todayStr = () => new Date().toISOString().split("T")[0];

// const nextDayStr = (dateStr) => {
//   const d = new Date(dateStr);
//   d.setDate(d.getDate() + 1);
//   return d.toISOString().split("T")[0];
// };

// const maxDueDateStr = () => {
//   const d = new Date();
//   d.setFullYear(d.getFullYear() + 5);
//   return d.toISOString().split("T")[0];
// };

// const formatINR = (num) => {
//   const n = Number(num);
//   if (isNaN(n)) return "0.00";
//   return n.toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });
// };

// // Inst Amount is now the directly-editable field; Percentage is
// // derived from it (of the pre-tax net fee base) purely for display.
// const computePercentage = (amount, netFeeBase) =>
//   (Number(netFeeBase) || 0) > 0
//     ? ((Number(amount) || 0) / Number(netFeeBase)) * 100
//     : 0;

// // Rupee SGST/CGST/Total GST/Gross Inst Amount for a single installment,
// // derived from that row's Inst Amount and the plan-level tax rates -
// // purely a display computation, mirroring the fee statement bill.
// const installmentTaxBreakup = (instAmount, sgstRate, cgstRate) => {
//   const base = Number(instAmount) || 0;
//   const sgst = (base * (Number(sgstRate) || 0)) / 100;
//   const cgst = (base * (Number(cgstRate) || 0)) / 100;
//   return { sgst, cgst, totalGst: sgst + cgst, grossAmount: base + sgst + cgst };
// };

// // Section header matching the /testscheduling grey-bar pattern
// // (.Header-1-C424342 + Minus/Plus toggle icon).
// const SectionHeader = ({ title, isOpen, onToggle }) => (
//   <div className="Header-1-C424342 nfp-section-header">
//     <span>{title}</span>
//     {isOpen ? (
//       <img
//         src={MinusImg}
//         alt="Toggle"
//         className="nfp-toggle-icon"
//         onClick={onToggle}
//       />
//     ) : (
//       <div className="plus nfp-toggle-plus" onClick={onToggle}>
//         +
//       </div>
//     )}
//   </div>
// );

// // ---------------------------------------------------------------------------
// // Component
// // ---------------------------------------------------------------------------

// function NewFeePlan({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setNoTimeSet,
//   setShowCloseButton,
// }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//   const instituteName =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_display_name || "";
//   const branchName = dataClient?.client_schema_name?.[6]?.[0]?.br_display_name || "";

//   // ---- Section collapse state ----
//   const [sectionOpen, setSectionOpen] = useState({
//     student: true,
//     fee: true,
//     installments: true,
//   });
//   const toggleSection = (key) =>
//     setSectionOpen((prev) => ({ ...prev, [key]: !prev[key] }));

//   // ---- Student search & selection ----
//   const [studentOptions, setStudentOptions] = useState([]);
//   const [selectedStudent, setSelectedStudent] = useState(null); // row from search-key API
//   const [studentProfile, setStudentProfile] = useState(null); // row from profile-details API
//   const [studentPhotoUrl, setStudentPhotoUrl] = useState(null);
//   const [isFetchingProfile, setIsFetchingProfile] = useState(false);

//   // Carried through read-only if the student already has it set on any
//   // existing plan (any session) - entered manually by accounts elsewhere,
//   // never editable here. Most students won't have one yet on a brand new
//   // plan, so this generally stays blank.
//   const [accStudentId, setAccStudentId] = useState(null);
//   const [registrationFormNo, setRegistrationFormNo] = useState("");

//   // ---- Sessions (for the installment due-date range check) ----
//   const [sessionsList, setSessionsList] = useState([]);
//   useEffect(() => {
//     fetch(EndPoints.GET_SESSIONS_LIST, { headers: { accept: "application/json" } })
//       .then((r) => r.json())
//       .then((data) => {
//         const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
//         setSessionsList(list);
//       })
//       .catch((err) => console.error("Error fetching sessions list:", err));
//   }, []);

//   // A new fee plan always belongs to the student's current session - not
//   // changeable here (unlike Edit Fee Plan, which can browse other
//   // sessions' plans).
//   const currentSession = sessionsList.find(
//     (s) => Number(s.session_id) === Number(studentProfile?.session_id)
//   );
//   const sessionStartDate = currentSession?.session_start_date
//     ? currentSession.session_start_date.split(" ")[0]
//     : "";
//   const sessionEndDate = currentSession?.session_end_date
//     ? currentSession.session_end_date.split(" ")[0]
//     : "";


//   // ---- Fee breakdown ----
//   const [totalFee, setTotalFee] = useState("");
//   const [scholarship, setScholarship] = useState("");
//   const [discount, setDiscount] = useState("");
//   // Hardcoded at 9% for now - these will come from an API in the future.
//   // Not directly user-editable in the UI; shown to the user as rupee
//   // amounts (SGST/CGST/Total GST) computed from this rate instead.
//   const [defaultSgst, setDefaultSgst] = useState("");
//   const [defaultCgst, setDefaultCgst] = useState("");

//   // ---- Batch Type (editable - prefilled from the student's enquiry,
//   // but course_fees is now split by batch type, so changing it needs
//   // to re-fetch the applicable fees) ----
//   const [batchTypes, setBatchTypes] = useState([]);
//   const [selectedBatchType, setSelectedBatchType] = useState(null);

//   // ---- Installments (default: 3 blank rows) ----
//   const [installments, setInstallments] = useState(
//     Array.from({ length: DEFAULT_INSTALLMENT_COUNT }, (_, i) => makeInstallment(i + 1))
//   );

//   // ---- Remarks / Additional ----
//   const [approvedBy, setApprovedBy] = useState("");
//   const [remarks, setRemarks] = useState("");

//   // Snapshot of form values taken right after a student (and any
//   // URL-prefilled sgst/cgst/baseFee) finishes loading - Cancel only
//   // warns about changes made after that point, not the act of arriving
//   // with a student already selected via a dashboard link.
//   const [pristineSnapshot, setPristineSnapshot] = useState(null);
//   useEffect(() => {
//     if (!studentProfile) return;
//     setPristineSnapshot(
//       JSON.stringify({
//         totalFee: String(totalFee ?? ""),
//         scholarship: String(scholarship ?? ""),
//         discount: String(discount ?? ""),
//         approvedBy: approvedBy || "",
//         remarks: remarks || "",
//         installments: installments.map((i) => ({
//           due_date: i.due_date,
//           amount: String(i.amount ?? ""),
//           remarks: i.remarks || "",
//         })),
//       })
//     );
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [studentProfile]);

//   // ---- UX state ----
//   const [showError, setShowError] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // ---- Fee computation ----
//   // Net Fee Payable = (Total Base Fee - Scholarship - Discount) + SGST + CGST,
//   // where SGST/CGST are computed on the post-scholarship/discount amount -
//   // matches the fee statement bill's Net Fee -> +GST -> Final Fee Amount flow.
//   const netFeeBase = Math.max(
//     0,
//     (Number(totalFee) || 0) - (Number(scholarship) || 0) - (Number(discount) || 0)
//   );
//   const sgstAmount = (netFeeBase * (Number(defaultSgst) || 0)) / 100;
//   const cgstAmount = (netFeeBase * (Number(defaultCgst) || 0)) / 100;
//   const totalGstAmount = sgstAmount + cgstAmount;
//   const netFee = netFeeBase + totalGstAmount;

//   // Installment totals (UI-only summary row - not sent to the API)
//   const installmentTotals = installments.reduce(
//     (acc, inst) => {
//       const instAmount = Number(inst.amount) || 0;
//       const { sgst, cgst, totalGst, grossAmount } = installmentTaxBreakup(
//         instAmount,
//         defaultSgst,
//         defaultCgst
//       );
//       acc.instAmount += instAmount;
//       acc.sgst += sgst;
//       acc.cgst += cgst;
//       acc.totalGst += totalGst;
//       acc.grossAmount += grossAmount;
//       return acc;
//     },
//     { instAmount: 0, sgst: 0, cgst: 0, totalGst: 0, grossAmount: 0 }
//   );

//   const notify = (message, isError = true) => {
//     setShowCloseButton(false);
//     if (isError) setNoTimeSet && setNoTimeSet(false);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX" style={{ width: "100%" }}>
//         <div className="messagebox-insider1" style={{ width: "100%" }}>
//           <span>{message}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(isError ? ErrorImg : InfoIcon);
//   };

//   // Same shared message box used for errors/warnings/save messages -
//   // shown while a selected student's data is loading.
//   const showLoading = (text) => {
//     setNoTimeSet && setNoTimeSet(true);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>{text}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(false);
//   };

//   // ---------------------------------------------------------------------
//   // Student search (search-key API)
//   // ---------------------------------------------------------------------
//   const fetchStudents = async (searchKeyInput) => {
//     if (!searchKeyInput || String(searchKeyInput).trim().length < 3) {
//       setStudentOptions([]);
//       return;
//     }
//     try {
//       const trimmed = String(searchKeyInput).trim();
//       const token = localStorage.getItem("other");
//       const response = await fetch(
//         `${EndPoints.SEARCH_STUDENTS_WITHOUT_FEE_PLAN}?search_key=${encodeURIComponent(
//           trimmed
//         )}`,
//         { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//       );
//       if (!response.ok) {
//         setStudentOptions([]);
//         return;
//       }
//       const data = await response.json();
//       const arr = Array.isArray(data)
//         ? data
//         : Array.isArray(data?.data)
//         ? data.data
//         : [];
//       setStudentOptions(arr);
//     } catch (err) {
//       console.error("Error searching students:", err);
//       setStudentOptions([]);
//     }
//   };

//   // Once a student is picked, fetch full profile details (course_id/session_id + photo)
//   const handleSelectStudent = async (option) => {
//     if (!option) {
//       setSelectedStudent(null);
//       setStudentProfile(null);
//       setStudentPhotoUrl(null);
//       setAccStudentId(null);
//       setBatchTypes([]);
//       setSelectedBatchType(null);
//       return;
//     }
//     setSelectedStudent(option);
//     setStudentProfile(null);
//     setStudentPhotoUrl(null);
//     setAccStudentId(null);
//     setBatchTypes([]);
//     setSelectedBatchType(null);
//     setDefaultSgst("");
//     setDefaultCgst("");
//     setTotalFee("");
//     setIsFetchingProfile(true);
//     showLoading("Loading data, please wait...");
//     let profileClassId = null;
//     let profileCourseId = null;
//     let profileBatchTypeId = null;
//     let hadError = false;
//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(
//         `${EndPoints.GET_STUDENT_ADMISSION_PROFILE}?student_id=${option.student_id}`,
//         { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//       );
//       const data = await response.json();
//       const profile = data?.data?.[0];
//       if (data?.status === 200 && profile) {
//         setStudentProfile(profile);
//         profileClassId = profile.class_id;
//         profileCourseId = profile.course_id;
//         profileBatchTypeId = profile.batch_type_id;
//         setSelectedStudent({
//           student_id: option.student_id,
//           student_full_name: option.student_full_name || profile.student_full_name || "",
//           roll_number: option.roll_number || profile.Roll_Number || "",
//           batch_name: option.batch_name || profile.Batch || "",
//         });
//         if (data?.signed_url && data.signed_url !== "URL not found") {
//           setStudentPhotoUrl(data.signed_url);
//         }
//       } else {
//         setStudentProfile(null);
//         notify("Could not fetch course/session details for this student.");
//         hadError = true;
//       }
//     } catch (err) {
//       console.error("Error fetching student profile:", err);
//       setStudentProfile(null);
//       notify("Could not fetch course/session details for this student.");
//       hadError = true;
//     } finally {
//       setIsFetchingProfile(false);
//     }

//     // Batch Type options are scoped to (class, course) together, not
//     // class alone - from the profile above, which succeeds
//     // independently of course_fees, so there's always a way to pick
//     // the right one regardless of whether the fee lookup below finds a
//     // match.
//     if (profileClassId != null && profileCourseId != null) {
//       fetchBatchTypes(profileClassId, profileCourseId);
//     }
//     setSelectedBatchType(profileBatchTypeId ?? null);

//     // SGST/CGST/Base Fee, matched using the batch type already on file
//     // for this student's enquiry - re-fetched below if the person
//     // changes the Batch Type dropdown.
//     const feesResult = await fetchCourseFees(option.student_id, profileBatchTypeId);
//     if (feesResult === null) hadError = true;

//     // Account Student ID is entered manually by accounts on a plan, and
//     // tends to stay the same across a student's plans/sessions once set -
//     // carry it forward here (read-only) if any existing plan already has
//     // one, rather than always starting blank on a brand new plan. In
//     // practice this will now always be a no-op, since students returned
//     // by search here are pre-filtered to have no existing plan at all -
//     // left in place in case this function is ever reused for a student
//     // who does have one.
//     try {
//       const token = localStorage.getItem("other");
//       const planResponse = await fetch(
//         `${EndPoints.GET_STUDENT_FEE_PLAN}?student_id=${option.student_id}`,
//         { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//       );
//       const planData = await planResponse.json();
//       const plans = Array.isArray(planData?.data) ? planData.data : [];
//       const planWithAccId = plans
//         .slice()
//         .sort((a, b) => b.fee_plan_id - a.fee_plan_id)
//         .find((p) => p.acc_student_id);
//       if (planWithAccId) {
//         setAccStudentId(planWithAccId.acc_student_id);
//       }
//     } catch (err) {
//       console.error("Error fetching existing fee plans:", err);
//     }
//     // Only clear the loading message on a clean run - if an error was
//     // shown along the way (notify() above, or from fetchCourseFees),
//     // leave it displayed instead of dismissing it the instant this
//     // function finishes.
//     if (!hadError) {
//       setIsMessageBoxVisible(false);
//     }
//   };

//   // SGST/CGST/Base Fee - fetched fresh per student (and re-fetched when
//   // the Batch Type dropdown changes) rather than relying on a URL param
//   // snapshot, so this works the same whether arriving via the
//   // dashboard's Roll Number link or a manual search here. No default
//   // rate is assumed if this comes back empty - a missing rate is a
//   // blocking error, not a silent 9% guess.
//   const fetchCourseFees = async (studentId, batchType) => {
//     try {
//       const token = localStorage.getItem("other");
//       const url =
//         batchType != null
//           ? `${EndPoints.GET_COURSE_FEES_FOR_STUDENT}?student_id=${studentId}&batch_type=${batchType}`
//           : `${EndPoints.GET_COURSE_FEES_FOR_STUDENT}?student_id=${studentId}`;
//       const feesResponse = await fetch(url, {
//         headers: { accept: "application/json", Authorization: `Bearer ${token}` },
//       });
//       const feesData = await feesResponse.json();
//       if (feesData?.status === 200 && feesData?.data) {
//         setDefaultSgst(feesData.data.sgst_prcnt);
//         setDefaultCgst(feesData.data.cgst_prcnt);
//         setTotalFee(feesData.data.base_fees);
//         return feesData.data;
//       }
//       setDefaultSgst("");
//       setDefaultCgst("");
//       setTotalFee("");
//       notify(
//         "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
//       );
//       return null;
//     } catch (err) {
//       console.error("Error fetching course fees:", err);
//       notify(
//         "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
//       );
//       return null;
//     }
//   };

//   // Batch Type options are scoped to the student's (class, course).
//   const fetchBatchTypes = async (classId, courseId) => {
//     if (classId == null || courseId == null) {
//       setBatchTypes([]);
//       return;
//     }
//     try {
//       const res = await fetch(
//         `${EndPoints.GET_BATCH_TYPES}?class_id=${classId}&course_id=${courseId}`,
//         { headers: { accept: "application/json" } }
//       );
//       const data = await res.json();
//       setBatchTypes(Array.isArray(data?.data) ? data.data : []);
//     } catch (err) {
//       console.error("Error fetching batch types:", err);
//       setBatchTypes([]);
//     }
//   };

//   // Batch Type changed on the form - refetch course fees for the newly
//   // selected batch type instead of the one defaulted from the enquiry.
//   const handleBatchTypeChange = async (batchTypeId) => {
//     setSelectedBatchType(batchTypeId);
//     if (selectedStudent?.student_id) {
//       await fetchCourseFees(selectedStudent.student_id, batchTypeId);
//     }
//   };

//   // If arriving from elsewhere (e.g. a dashboard's Roll Number link) with a
//   // known student, skip the manual search and load them directly.
//   // SGST/CGST/Base Fee are no longer read from URL params here - they're
//   // fetched fresh inside handleSelectStudent below (get-course-fees-for-
//   // student), which runs for this path and for manual search alike, so
//   // both end up using the exact same source instead of two different
//   // mechanisms that could disagree.
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const prefillId = params.get("studentId");
//     if (prefillId) {
//       handleSelectStudent({ student_id: prefillId });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ---------------------------------------------------------------------
//   // Installments
//   // ---------------------------------------------------------------------
//   const handleAddInstallment = () => {
//     if (installments.length >= 12) {
//       notify("A fee plan can have at most 12 installments.");
//       return;
//     }
//     setInstallments((prev) => [...prev, makeInstallment(prev.length + 1)]);
//   };

//   // The add-installment button only shows while the last row is being
//   // written in - tracked via focus bubbling up from its fields (React's
//   // onFocus/onBlur bubble even though FormInputs doesn't forward these
//   // as props). Blur hides it after a short delay rather than
//   // immediately, so a click on the button itself (which briefly blurs
//   // the field first) still has time to register before it disappears.
//   const [isLastRowActive, setIsLastRowActive] = useState(false);
//   const lastRowBlurTimeoutRef = useRef(null);
//   const handleLastRowFocus = () => {
//     if (lastRowBlurTimeoutRef.current) clearTimeout(lastRowBlurTimeoutRef.current);
//     setIsLastRowActive(true);
//   };
//   const handleLastRowBlur = () => {
//     lastRowBlurTimeoutRef.current = setTimeout(() => setIsLastRowActive(false), 200);
//   };

//   const handleRemoveInstallment = (key) => {
//     setInstallments((prev) =>
//       prev
//         .filter((inst) => inst.key !== key)
//         .map((inst, idx) => ({ ...inst, installment_no: idx + 1 }))
//     );
//   };

//   const handleInstallmentField = (key, field, value) => {
//     setInstallments((prev) =>
//       prev.map((inst) => (inst.key === key ? { ...inst, [field]: value } : inst))
//     );
//   };

//   // ---------------------------------------------------------------------
//   // Reset / cancel
//   // ---------------------------------------------------------------------
//   const resetForm = () => {
//     setSelectedStudent(null);
//     setStudentProfile(null);
//     setStudentPhotoUrl(null);
//     setStudentOptions([]);
//     setAccStudentId(null);
//     setRegistrationFormNo("");
//     setTotalFee("");
//     setScholarship("");
//     setDiscount("");
//     setDefaultSgst("9");
//     setDefaultCgst("9");
//     setInstallments(
//       Array.from({ length: DEFAULT_INSTALLMENT_COUNT }, (_, i) => makeInstallment(i + 1))
//     );
//     setApprovedBy("");
//     setRemarks("");
//     setShowError(false);
//     setPristineSnapshot(null);
//   };

//   // True once the person has actually changed something from what was
//   // loaded (or prefilled via URL) - used to decide whether Cancel needs
//   // to confirm at all.
//   const isFormDirty = () => {
//     if (pristineSnapshot === null) return false;
//     const currentSnapshot = JSON.stringify({
//       totalFee: String(totalFee ?? ""),
//       scholarship: String(scholarship ?? ""),
//       discount: String(discount ?? ""),
//       approvedBy: approvedBy || "",
//       remarks: remarks || "",
//       installments: installments.map((i) => ({
//         due_date: i.due_date,
//         amount: String(i.amount ?? ""),
//         remarks: i.remarks || "",
//       })),
//     });
//     return currentSnapshot !== pristineSnapshot;
//   };

//   const handleCancel = () => {
//     if (!isFormDirty()) {
//       navigate("/fee_plan_dashboard");
//       return;
//     }

//     setShowCloseButton(false);
//     setNoTimeSet(true); // keep the box open (it normally auto-closes after 3.5s) until Yes/No is clicked
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Are you sure you want to cancel? Unsaved changes will be lost.</span>
//         </div>
//         <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               setNoTimeSet(false);
//               navigate("/fee_plan_dashboard");
//             }}
//           >
//             Yes
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               setNoTimeSet(false);
//             }}
//           >
//             No
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // ---------------------------------------------------------------------
//   // Submit
//   // ---------------------------------------------------------------------
//   const handleSubmit = async () => {
//     setShowError(true);

//     if (!selectedStudent) {
//       notify("Please search and select a student.");
//       return;
//     }
//     if (!selectedBatchType) {
//       notify("Please select a Batch Type.");
//       return;
//     }
//     if (!studentProfile?.course_id || !studentProfile?.session_id) {
//       notify("Course/session details are unavailable for this student.");
//       return;
//     }
//     if (!totalFee || Number(totalFee) <= 0) {
//       notify("Please enter a valid Total Base Fee.");
//       return;
//     }
//     if (!defaultSgst || !defaultCgst) {
//       notify(
//         "No SGST/CGST rate is configured for this course/session/branch/class combination - please contact your administrator to configure this."
//       );
//       return;
//     }
//     if (installments.length === 0) {
//       notify("Please add at least one installment.");
//       return;
//     }
//     for (const inst of installments) {
//       if (!inst.due_date || !inst.amount || Number(inst.amount) <= 0) {
//         notify("Please complete the due date and amount for every installment.");
//         return;
//       }
//       if (computePercentage(inst.amount, netFeeBase) > 100) {
//         notify(`Installment ${inst.installment_no}'s amount can't be more than the net fee (100%).`);
//         return;
//       }
//       if (inst.due_date < todayStr()) {
//         notify(
//           `Installment ${inst.installment_no}'s due date can't be in the past - it must be today or later.`
//         );
//         return;
//       }
//       if (sessionEndDate && inst.due_date > sessionEndDate) {
//         notify(
//           `Installment ${inst.installment_no}'s due date can't be after the session's end date (${sessionEndDate}).`
//         );
//         return;
//       }
//     }
//     for (let i = 1; i < installments.length; i++) {
//       if (installments[i].due_date <= installments[i - 1].due_date) {
//         notify(
//           `Installment ${installments[i].installment_no}'s due date must be later than installment ${installments[i - 1].installment_no}'s due date.`
//         );
//         return;
//       }
//     }
//     if ((Number(scholarship) > 0 || Number(discount) > 0) && !remarks.trim()) {
//       notify("Remarks are required when a scholarship or concession is applied.");
//       return;
//     }
//     if (Math.abs(installmentTotals.instAmount - netFeeBase) > 1) {
//       notify(
//         `Installment amounts (₹ ${formatINR(
//           installmentTotals.instAmount
//         )}) do not add up to the Net Fee (₹ ${formatINR(
//           netFeeBase
//         )}). Please adjust the installment amount to match net fee.`
//       );
//       return;
//     }
//     if (!userName) {
//       notify("Unable to determine the logged-in user. Please re-login and try again.");
//       return;
//     }

//     // Only the fields expected by create-student-fee-plan are sent - the
//     // percentage, rupee tax breakup, Total row, etc. are UI-only.
//     const payload = {
//       student_id: Number(selectedStudent.student_id),
//       session_id: Number(studentProfile.session_id),
//       course_id: Number(studentProfile.course_id),
//       reg_form_no: registrationFormNo || null,
//       total_fee_inr: Number(totalFee),
//       scholarship_amount: Number(scholarship) || 0,
//       discount_amount: Number(discount) || 0,
//       net_fee: Number(netFee),
//       sgst: sgstAmount,
//       cgst: cgstAmount,
//       remarks: remarks || null,
//       approved_by: approvedBy || null,
//       username: userName,
//       fee_schedule_list: installments.map((inst) => {
//         const instAmount = Number(inst.amount) || 0;
//         const breakup = installmentTaxBreakup(instAmount, defaultSgst, defaultCgst);
//         return {
//           installment_no: inst.installment_no,
//           due_date: inst.due_date,
//           amount: Number(instAmount),
//           sgst: breakup.sgst,
//           cgst: breakup.cgst,
//           remarks: inst.remarks || null,
//         };
//       }),
//     };

//     setIsSubmitting(true);
//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(EndPoints.CREATE_STUDENT_FEE_PLAN, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify(payload),
//       });
//       const data = await response.json();

//       if (data?.status === 200) {
//         notify(data.message || "Student fee plan created successfully.", false);
//         resetForm();
//       } else {
//         notify(data?.message || "Failed to create student fee plan.");
//       }
//     } catch (err) {
//       console.error("Error creating fee plan:", err);
//       notify("An error occurred while creating the fee plan.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="nfp-container">
//       <div className="nfp-interactive">
//         {/* ---------------- Header (matches /testscheduling page header) ---------------- */}
//         <div className="nfp-header-sticky">
//           <div className="nfp-page-header">
//             <div className="nfp-page-title">Fee Plan</div>
//             <div className="nfp-header-btns">
//               <button
//                 className="create-test-section-btn"
//                 style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={handleCancel}
//                 disabled={isSubmitting}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={handleSubmit}
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "SAVING..." : "SAVE"}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* ---------------- Student & Course Details ---------------- */}
//         <div className="nfp-section">
//           <SectionHeader
//             title="STUDENT & COURSE DETAILS"
//             isOpen={sectionOpen.student}
//             onToggle={() => toggleSection("student")}
//           />
//           {sectionOpen.student && (
//             <div className="Body-1-C424342 nfp-section-body">
//               <div className="nfp-grid-3">
//                 {selectedStudent || studentProfile ? (
//                   <FormInputs
//                     label="Student"
//                     disabled
//                     value={
//                       selectedStudent?.student_full_name ||
//                       studentProfile?.student_full_name ||
//                       ""
//                     }
//                   />
//                 ) : (
//                   <div className="nfp-field">
//                     <SearchDropdown
//                       label="Student *"
//                       placeholder="Search student"
//                       initialOptions={studentOptions}
//                       onInputChange={fetchStudents}
//                       onSelect={handleSelectStudent}
//                       selected={selectedStudent}
//                       hasError={showError && !selectedStudent}
//                       labelKey={(opt) =>
//                         `${opt.student_full_name || ""} / ${opt.roll_number || ""} / ${
//                           opt.batch_name || ""
//                         }`
//                       }
//                     />
//                   </div>
//                 )}
//                 <FormInputs
//                   label="Roll No"
//                   disabled
//                   value={studentProfile?.Roll_Number || ""}
//                 />
//                 <FormInputs
//                   label="Batch"
//                   disabled
//                   value={studentProfile?.Batch || ""}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <div className="formInput">
//                   <label>
//                     Batch Type
//                     <span>*</span>
//                   </label>
//                   <DropDown
//                     selected={selectedBatchType}
//                     setSelected={handleBatchTypeChange}
//                     options={batchTypes.map((bt) => ({
//                       id: bt.batch_type_id,
//                       label: bt.batch_type_desc,
//                     }))}
//                     placeholder={batchTypes.length === 0 ? "No batch types for this class" : "Select batch type"}
//                     disabled={batchTypes.length === 0}
//                     Height="auto"
//                     minheight="150px"
//                     OverFlow="auto"
//                   />
//                 </div>
//                 <FormInputs
//                   label="Class"
//                   disabled
//                   value={studentProfile?.Class_name || ""}
//                 />
//                 <FormInputs
//                   label="Course"
//                   disabled
//                   value={studentProfile?.Course_Name || ""}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Father/Mother/Guardian"
//                   disabled
//                   value={
//                     studentProfile?.father_name ||
//                     studentProfile?.mother_name ||
//                     studentProfile?.guardian_name ||
//                     ""
//                   }
//                 />
//                 <FormInputs
//                   label="Session"
//                   disabled
//                   value={studentProfile?.session || ""}
//                 />
//                 <FormInputs
//                   label="Enquiry Date"
//                   disabled
//                   value={studentProfile?.admission_date || ""}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Account Student ID"
//                   disabled
//                   value={accStudentId || ""}
//                 />
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ---------------- Fee Details ---------------- */}
//         <div className="nfp-section">
//           <SectionHeader
//             title="FEE DETAILS"
//             isOpen={sectionOpen.fee}
//             onToggle={() => toggleSection("fee")}
//           />
//           {sectionOpen.fee && (
//             <div className="Body-1-C424342 nfp-section-body">
//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Base Fee (₹)"
//                   required
//                   showError={showError}
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   placeholder="0.00"
//                   value={totalFee}
//                   onChange={(e) => setTotalFee(e.target.value)}
//                 />
//                 <FormInputs
//                   label="Scholarship (₹)"
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   placeholder="0.00"
//                   value={scholarship}
//                   onChange={(e) => setScholarship(e.target.value)}
//                 />
//                 <FormInputs
//                   label="Concession (₹)"
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   placeholder="0.00"
//                   value={discount}
//                   onChange={(e) => setDiscount(e.target.value)}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs label="Net Fee (₹)" value={`${formatINR(netFeeBase)}`} disabled />
//                 <FormInputs label="SGST (₹)" value={`${formatINR(sgstAmount)}`} disabled />
//                 <FormInputs label="CGST (₹)" value={`${formatINR(cgstAmount)}`} disabled />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Total Fees Payable (₹)"
//                   value={`${formatINR(netFee)}`}
//                   disabled
//                 />
//                 <FormInputs
//                   label="Approved By"
//                   placeholder="Name of approving authority"
//                   value={approvedBy}
//                   maxLength={10}
//                   onChange={(e) => setApprovedBy(e.target.value)}
//                 />
//                 <FormInputs
//                   label="Remarks"
//                   placeholder="Add any notes regarding this fee plan..."
//                   value={remarks}
//                   maxLength={500}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   required={Number(scholarship) > 0 || Number(discount) > 0}
//                   showError={showError}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Registration Form No."
//                   placeholder="Enter registration form number"
//                   value={registrationFormNo}
//                   maxLength={10}
//                   onChange={(e) => setRegistrationFormNo(e.target.value)}
//                 />
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ---------------- Installment Schedule ---------------- */}
//         <div className="nfp-section">
//           <div className="Header-1-C424342 nfp-section-header">
//             <span>INSTALLMENT SCHEDULE</span>
//             {sectionOpen.installments ? (
//               <img
//                 src={MinusImg}
//                 alt="Toggle"
//                 className="nfp-toggle-icon"
//                 onClick={() => toggleSection("installments")}
//               />
//             ) : (
//               <div
//                 className="plus nfp-toggle-plus"
//                 onClick={() => toggleSection("installments")}
//               >
//                 +
//               </div>
//             )}
//           </div>

//           {sectionOpen.installments && (
//             <div className="Body-1-C424342 nfp-section-body nfp-section-body-flush">
//               <div className="nfp-table-wrap">
//                 <table className="nfp-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "48px" }}></th>
//                       <th style={{ width: "60px" }}>Inst. No</th>
//                       <th>Due Date</th>
//                       <th>Inst Amount (₹)</th>
//                       <th>Percentage (%)</th>
//                       <th>SGST (₹)</th>
//                       <th>CGST (₹)</th>
//                       <th>Total GST (₹)</th>
//                       <th>Gross Inst Amount (₹)</th>
//                       <th>Remarks</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {installments.map((inst, idx) => {
//                       const instAmount = Number(inst.amount) || 0;
//                       const breakup = installmentTaxBreakup(
//                         instAmount,
//                         defaultSgst,
//                         defaultCgst
//                       );
//                       const isLastRow = idx === installments.length - 1;
//                       const previousDueDate = idx > 0 ? installments[idx - 1].due_date : null;
//                       const minDueDate =
//                         previousDueDate && nextDayStr(previousDueDate) > todayStr()
//                           ? nextDayStr(previousDueDate)
//                           : todayStr();
//                       return (
//                         <tr
//                           key={inst.key}
//                           onFocus={isLastRow ? handleLastRowFocus : undefined}
//                           onBlur={isLastRow ? handleLastRowBlur : undefined}
//                         >
//                           <td className="nfp-row-remove">
//                             <div className="nfp-row-remove-spacer"></div>
//                             {installments.length > 1 && (
//                               <span
//                                 className="nfp-remove-btn"
//                                 onClick={() => handleRemoveInstallment(inst.key)}
//                                 title="Remove installment"
//                               >
//                                 ×
//                               </span>
//                             )}
//                           </td>
//                           <td className="nfp-inst-no">{inst.installment_no}</td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               type="date"
//                               required
//                               showError={showError}
//                               min={minDueDate}
//                               max={sessionEndDate || maxDueDateStr()}
//                               value={inst.due_date}
//                               onChange={(e) =>
//                                 handleInstallmentField(inst.key, "due_date", e.target.value)
//                               }
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               type="number"
//                               required
//                               showError={showError}
//                               min="0"
//                               step="0.01"
//                               placeholder="0"
//                               value={inst.amount}
//                               onChange={(e) =>
//                                 handleInstallmentField(inst.key, "amount", e.target.value)
//                               }
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               value={`${computePercentage(inst.amount, netFeeBase).toFixed(2)}`}
//                               disabled
//                             />
//                           </td>
//                           <td>
//                             <FormInputs label="" value={`${formatINR(breakup.sgst)}`} disabled />
//                           </td>
//                           <td>
//                             <FormInputs label="" value={`${formatINR(breakup.cgst)}`} disabled />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               value={`${formatINR(breakup.totalGst)}`}
//                               disabled
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               value={`${formatINR(breakup.grossAmount)}`}
//                               disabled
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               placeholder="Optional"
//                               value={inst.remarks}
//                               className="nfp-remarks-input"
//                               onChange={(e) =>
//                                 handleInstallmentField(inst.key, "remarks", e.target.value)
//                               }
//                             />
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     {isLastRowActive && (
//                       <tr className="nfp-add-installment-row-inline">
//                         <td colSpan={9}></td>
//                         <td style={{ textAlign: "right" }}>
//                           <img
//                             src={YellowPlus}
//                             alt="Add installment"
//                             className="nfp-add-icon"
//                             onMouseDown={(e) => e.preventDefault()}
//                             onClick={handleAddInstallment}
//                             title="Add installment"
//                           />
//                         </td>
//                       </tr>
//                     )}
//                     {/* UI-only summary row - not part of fee_schedule_list */}
//                     <tr className="nfp-total-row">
//                       <td></td>
//                       <td colSpan={2}>Total</td>
//                       <td>₹ {formatINR(installmentTotals.instAmount)}</td>
//                       <td></td>
//                       <td>₹ {formatINR(installmentTotals.sgst)}</td>
//                       <td>₹ {formatINR(installmentTotals.cgst)}</td>
//                       <td>₹ {formatINR(installmentTotals.totalGst)}</td>
//                       <td>₹ {formatINR(installmentTotals.grossAmount)}</td>
//                       <td></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               <div className="nfp-installment-total-row">
//                 <span>Net Fee Payable: ₹ {formatINR(netFee)}</span>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default NewFeePlan;












import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./newFeePlan.css";
import "../CreateQuestionsPaper/TestScheduling/testscheduling.css";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import FormDateInput from "../../Components/Shared/FormDateInput/FormDateInput";
import { formatDisplayDate } from "../../Components/Shared/FormDateInput/dateFormat";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import SearchDropdown from "../../Components/SearchDropdownforListDataSingleSelect/SearchdropdownforlistdataSingleSelect";
import EndPoints from "../../Api/EndPoints";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import InfoIcon from "../../Assets/Images/CommanImages/Informative.png";
import MinusImg from "../../Assets/Images/CommanImages/MinusGrey.png";
import YellowPlus from "../../Assets/Images/CommanImages/YellowPlus.png";

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

const makeInstallment = (installment_no) => ({
  key: `inst_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  installment_no,
  due_date: "",
  amount: "",
  remarks: "",
});

const DEFAULT_INSTALLMENT_COUNT = 3;

const todayStr = () => new Date().toISOString().split("T")[0];

const nextDayStr = (dateStr) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + 1);
  return d.toISOString().split("T")[0];
};

const maxDueDateStr = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() + 5);
  return d.toISOString().split("T")[0];
};

const formatINR = (num) => {
  const n = Number(num);
  if (isNaN(n)) return "0.00";
  return n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Inst Amount is now the directly-editable field; Percentage is
// derived from it (of the pre-tax net fee base) purely for display.
const computePercentage = (amount, netFeeBase) =>
  (Number(netFeeBase) || 0) > 0
    ? ((Number(amount) || 0) / Number(netFeeBase)) * 100
    : 0;

// Rupee SGST/CGST/Total GST/Gross Inst Amount for a single installment,
// derived from that row's Inst Amount and the plan-level tax rates -
// purely a display computation, mirroring the fee statement bill.
const installmentTaxBreakup = (instAmount, sgstRate, cgstRate) => {
  const base = Number(instAmount) || 0;
  const sgst = (base * (Number(sgstRate) || 0)) / 100;
  const cgst = (base * (Number(cgstRate) || 0)) / 100;
  return { sgst, cgst, totalGst: sgst + cgst, grossAmount: base + sgst + cgst };
};

// Section header matching the /testscheduling grey-bar pattern
// (.Header-1-C424342 + Minus/Plus toggle icon).
const SectionHeader = ({ title, isOpen, onToggle }) => (
  <div className="Header-1-C424342 nfp-section-header">
    <span>{title}</span>
    {isOpen ? (
      <img
        src={MinusImg}
        alt="Toggle"
        className="nfp-toggle-icon"
        onClick={onToggle}
      />
    ) : (
      <div className="plus nfp-toggle-plus" onClick={onToggle}>
        +
      </div>
    )}
  </div>
);

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

function NewFeePlan({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setNoTimeSet,
  setShowCloseButton,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
  const instituteName =
    dataClient?.client_schema_name?.[6]?.[0]?.client_display_name || "";
  const branchName = dataClient?.client_schema_name?.[6]?.[0]?.br_display_name || "";

  // ---- Section collapse state ----
  const [sectionOpen, setSectionOpen] = useState({
    student: true,
    fee: true,
    installments: true,
  });
  const toggleSection = (key) =>
    setSectionOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  // ---- Student search & selection ----
  const [studentOptions, setStudentOptions] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null); // row from search-key API
  const [studentProfile, setStudentProfile] = useState(null); // row from profile-details API
  const [studentPhotoUrl, setStudentPhotoUrl] = useState(null);
  const [isFetchingProfile, setIsFetchingProfile] = useState(false);

  // Carried through read-only if the student already has it set on any
  // existing plan (any session) - entered manually by accounts elsewhere,
  // never editable here. Most students won't have one yet on a brand new
  // plan, so this generally stays blank.
  const [accStudentId, setAccStudentId] = useState(null);
  const [registrationFormNo, setRegistrationFormNo] = useState("");

  // ---- Sessions (for the installment due-date range check) ----
  const [sessionsList, setSessionsList] = useState([]);
  useEffect(() => {
    fetch(EndPoints.GET_SESSIONS_LIST, { headers: { accept: "application/json" } })
      .then((r) => r.json())
      .then((data) => {
        const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        setSessionsList(list);
      })
      .catch((err) => console.error("Error fetching sessions list:", err));
  }, []);

  // A new fee plan always belongs to the student's current session - not
  // changeable here (unlike Edit Fee Plan, which can browse other
  // sessions' plans).
  const currentSession = sessionsList.find(
    (s) => Number(s.session_id) === Number(studentProfile?.session_id)
  );
  const sessionStartDate = currentSession?.session_start_date
    ? currentSession.session_start_date.split(" ")[0]
    : "";
  const sessionEndDate = currentSession?.session_end_date
    ? currentSession.session_end_date.split(" ")[0]
    : "";


  // ---- Fee breakdown ----
  const [totalFee, setTotalFee] = useState("");
  const [scholarship, setScholarship] = useState("");
  const [discount, setDiscount] = useState("");
  // Hardcoded at 9% for now - these will come from an API in the future.
  // Not directly user-editable in the UI; shown to the user as rupee
  // amounts (SGST/CGST/Total GST) computed from this rate instead.
  const [defaultSgst, setDefaultSgst] = useState("");
  const [defaultCgst, setDefaultCgst] = useState("");

  // ---- Batch Type (editable - prefilled from the student's enquiry,
  // but course_fees is now split by batch type, so changing it needs
  // to re-fetch the applicable fees) ----
  const [batchTypes, setBatchTypes] = useState([]);
  const [selectedBatchType, setSelectedBatchType] = useState(null);

  // ---- Installments (default: 3 blank rows) ----
  const [installments, setInstallments] = useState(
    Array.from({ length: DEFAULT_INSTALLMENT_COUNT }, (_, i) => makeInstallment(i + 1))
  );

  // ---- Remarks / Additional ----
  const [approvedBy, setApprovedBy] = useState("");
  const [remarks, setRemarks] = useState("");

  // Snapshot of form values taken right after a student (and any
  // URL-prefilled sgst/cgst/baseFee) finishes loading - Cancel only
  // warns about changes made after that point, not the act of arriving
  // with a student already selected via a dashboard link.
  const [pristineSnapshot, setPristineSnapshot] = useState(null);
  useEffect(() => {
    if (!studentProfile) return;
    setPristineSnapshot(
      JSON.stringify({
        totalFee: String(totalFee ?? ""),
        scholarship: String(scholarship ?? ""),
        discount: String(discount ?? ""),
        approvedBy: approvedBy || "",
        remarks: remarks || "",
        installments: installments.map((i) => ({
          due_date: i.due_date,
          amount: String(i.amount ?? ""),
          remarks: i.remarks || "",
        })),
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentProfile]);

  // ---- UX state ----
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ---- Fee computation ----
  // Net Fee Payable = (Total Base Fee - Scholarship - Discount) + SGST + CGST,
  // where SGST/CGST are computed on the post-scholarship/discount amount -
  // matches the fee statement bill's Net Fee -> +GST -> Final Fee Amount flow.
  // A scholarship or concession needs a paper trail - Approved By and
  // Remarks both become mandatory whenever either one is applied.
  const isConcessionApplied = Number(scholarship) > 0 || Number(discount) > 0;

  const netFeeBase = Math.max(
    0,
    (Number(totalFee) || 0) - (Number(scholarship) || 0) - (Number(discount) || 0)
  );
  const sgstAmount = (netFeeBase * (Number(defaultSgst) || 0)) / 100;
  const cgstAmount = (netFeeBase * (Number(defaultCgst) || 0)) / 100;
  const totalGstAmount = sgstAmount + cgstAmount;
  const netFee = netFeeBase + totalGstAmount;

  // Installment totals (UI-only summary row - not sent to the API)
  const installmentTotals = installments.reduce(
    (acc, inst) => {
      const instAmount = Number(inst.amount) || 0;
      const { sgst, cgst, totalGst, grossAmount } = installmentTaxBreakup(
        instAmount,
        defaultSgst,
        defaultCgst
      );
      acc.instAmount += instAmount;
      acc.sgst += sgst;
      acc.cgst += cgst;
      acc.totalGst += totalGst;
      acc.grossAmount += grossAmount;
      return acc;
    },
    { instAmount: 0, sgst: 0, cgst: 0, totalGst: 0, grossAmount: 0 }
  );

  const notify = (message, isError = true) => {
    setShowCloseButton(false);
    if (isError) setNoTimeSet && setNoTimeSet(false);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX" style={{ width: "100%" }}>
        <div className="messagebox-insider1" style={{ width: "100%" }}>
          <span>{message}</span>
        </div>
      </div>
    );
    setActiveImg(isError ? ErrorImg : InfoIcon);
  };

  // Same shared message box used for errors/warnings/save messages -
  // shown while a selected student's data is loading.
  const showLoading = (text) => {
    setNoTimeSet && setNoTimeSet(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>{text}</span>
        </div>
      </div>
    );
    setActiveImg(false);
  };

  // ---------------------------------------------------------------------
  // Student search (search-key API)
  // ---------------------------------------------------------------------
  const fetchStudents = async (searchKeyInput) => {
    if (!searchKeyInput || String(searchKeyInput).trim().length < 3) {
      setStudentOptions([]);
      return;
    }
    try {
      const trimmed = String(searchKeyInput).trim();
      const token = localStorage.getItem("other");
      const response = await fetch(
        `${EndPoints.SEARCH_STUDENTS_WITHOUT_FEE_PLAN}?search_key=${encodeURIComponent(
          trimmed
        )}`,
        { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) {
        setStudentOptions([]);
        return;
      }
      const data = await response.json();
      const arr = Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
        ? data.data
        : [];
      setStudentOptions(arr);
    } catch (err) {
      console.error("Error searching students:", err);
      setStudentOptions([]);
    }
  };

  // Once a student is picked, fetch full profile details (course_id/session_id + photo)
  const handleSelectStudent = async (option) => {
    if (!option) {
      setSelectedStudent(null);
      setStudentProfile(null);
      setStudentPhotoUrl(null);
      setAccStudentId(null);
      setBatchTypes([]);
      setSelectedBatchType(null);
      return;
    }
    setSelectedStudent(option);
    setStudentProfile(null);
    setStudentPhotoUrl(null);
    setAccStudentId(null);
    setBatchTypes([]);
    setSelectedBatchType(null);
    setDefaultSgst("");
    setDefaultCgst("");
    setTotalFee("");
    setIsFetchingProfile(true);
    showLoading("Loading data, please wait...");
    let profileClassId = null;
    let profileCourseId = null;
    let profileBatchTypeId = null;
    let hadError = false;
    try {
      const token = localStorage.getItem("other");
      const response = await fetch(
        `${EndPoints.GET_STUDENT_ADMISSION_PROFILE}?student_id=${option.student_id}`,
        { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();
      const profile = data?.data?.[0];
      if (data?.status === 200 && profile) {
        setStudentProfile(profile);
        profileClassId = profile.class_id;
        profileCourseId = profile.course_id;
        profileBatchTypeId = profile.batch_type_id;
        setSelectedStudent({
          student_id: option.student_id,
          student_full_name: option.student_full_name || profile.student_full_name || "",
          roll_number: option.roll_number || profile.Roll_Number || "",
          batch_name: option.batch_name || profile.Batch || "",
        });
        if (data?.signed_url && data.signed_url !== "URL not found") {
          setStudentPhotoUrl(data.signed_url);
        }
      } else {
        setStudentProfile(null);
        notify("Could not fetch course/session details for this student.");
        hadError = true;
      }
    } catch (err) {
      console.error("Error fetching student profile:", err);
      setStudentProfile(null);
      notify("Could not fetch course/session details for this student.");
      hadError = true;
    } finally {
      setIsFetchingProfile(false);
    }

    // Batch Type options are scoped to (class, course) together, not
    // class alone - from the profile above, which succeeds
    // independently of course_fees, so there's always a way to pick
    // the right one regardless of whether the fee lookup below finds a
    // match.
    if (profileClassId != null && profileCourseId != null) {
      fetchBatchTypes(profileClassId, profileCourseId);
    }
    setSelectedBatchType(profileBatchTypeId ?? null);

    // SGST/CGST/Base Fee, matched using the batch type already on file
    // for this student's enquiry - re-fetched below if the person
    // changes the Batch Type dropdown.
    const feesResult = await fetchCourseFees(option.student_id, profileBatchTypeId);
    if (feesResult === null) hadError = true;

    // Account Student ID is entered manually by accounts on a plan, and
    // tends to stay the same across a student's plans/sessions once set -
    // carry it forward here (read-only) if any existing plan already has
    // one, rather than always starting blank on a brand new plan. In
    // practice this will now always be a no-op, since students returned
    // by search here are pre-filtered to have no existing plan at all -
    // left in place in case this function is ever reused for a student
    // who does have one.
    try {
      const token = localStorage.getItem("other");
      const planResponse = await fetch(
        `${EndPoints.GET_STUDENT_FEE_PLAN}?student_id=${option.student_id}`,
        { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
      );
      const planData = await planResponse.json();
      const plans = Array.isArray(planData?.data) ? planData.data : [];
      const planWithAccId = plans
        .slice()
        .sort((a, b) => b.fee_plan_id - a.fee_plan_id)
        .find((p) => p.acc_student_id);
      if (planWithAccId) {
        setAccStudentId(planWithAccId.acc_student_id);
      }
    } catch (err) {
      console.error("Error fetching existing fee plans:", err);
    }
    // Only clear the loading message on a clean run - if an error was
    // shown along the way (notify() above, or from fetchCourseFees),
    // leave it displayed instead of dismissing it the instant this
    // function finishes.
    if (!hadError) {
      setIsMessageBoxVisible(false);
    }
  };

  // SGST/CGST/Base Fee - fetched fresh per student (and re-fetched when
  // the Batch Type dropdown changes) rather than relying on a URL param
  // snapshot, so this works the same whether arriving via the
  // dashboard's Roll Number link or a manual search here. No default
  // rate is assumed if this comes back empty - a missing rate is a
  // blocking error, not a silent 9% guess.
  const fetchCourseFees = async (studentId, batchType) => {
    try {
      const token = localStorage.getItem("other");
      const url =
        batchType != null
          ? `${EndPoints.GET_COURSE_FEES_FOR_STUDENT}?student_id=${studentId}&batch_type=${batchType}`
          : `${EndPoints.GET_COURSE_FEES_FOR_STUDENT}?student_id=${studentId}`;
      const feesResponse = await fetch(url, {
        headers: { accept: "application/json", Authorization: `Bearer ${token}` },
      });
      const feesData = await feesResponse.json();
      if (feesData?.status === 200 && feesData?.data) {
        setDefaultSgst(feesData.data.sgst_prcnt);
        setDefaultCgst(feesData.data.cgst_prcnt);
        setTotalFee(feesData.data.base_fees);
        return feesData.data;
      }
      setDefaultSgst("");
      setDefaultCgst("");
      setTotalFee("");
      notify(
        "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
      );
      return null;
    } catch (err) {
      console.error("Error fetching course fees:", err);
      notify(
        "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
      );
      return null;
    }
  };

  // Batch Type options are scoped to the student's (class, course).
  const fetchBatchTypes = async (classId, courseId) => {
    if (classId == null || courseId == null) {
      setBatchTypes([]);
      return;
    }
    try {
      const res = await fetch(
        `${EndPoints.GET_BATCH_TYPES}?class_id=${classId}&course_id=${courseId}`,
        { headers: { accept: "application/json" } }
      );
      const data = await res.json();
      setBatchTypes(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error("Error fetching batch types:", err);
      setBatchTypes([]);
    }
  };

  // Batch Type changed on the form - refetch course fees for the newly
  // selected batch type instead of the one defaulted from the enquiry.
  const handleBatchTypeChange = async (batchTypeId) => {
    setSelectedBatchType(batchTypeId);
    if (selectedStudent?.student_id) {
      await fetchCourseFees(selectedStudent.student_id, batchTypeId);
    }
  };

  // Only one batch type available for this class/course - there's nothing
  // to actually choose, so select it automatically instead of leaving the
  // dropdown sitting empty and locked.
  useEffect(() => {
    if (batchTypes.length === 1) {
      handleBatchTypeChange(batchTypes[0].batch_type_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchTypes]);

  // If arriving from elsewhere (e.g. a dashboard's Roll Number link) with a
  // known student, skip the manual search and load them directly.
  // SGST/CGST/Base Fee are no longer read from URL params here - they're
  // fetched fresh inside handleSelectStudent below (get-course-fees-for-
  // student), which runs for this path and for manual search alike, so
  // both end up using the exact same source instead of two different
  // mechanisms that could disagree.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const prefillId = params.get("studentId");
    if (prefillId) {
      handleSelectStudent({ student_id: prefillId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------------------------------------------------------
  // Installments
  // ---------------------------------------------------------------------
  const handleAddInstallment = () => {
    if (installments.length >= 12) {
      notify("A fee plan can have at most 12 installments.");
      return;
    }
    setInstallments((prev) => [...prev, makeInstallment(prev.length + 1)]);
  };

  // The add-installment button only shows while the last row is being
  // written in - tracked via focus bubbling up from its fields (React's
  // onFocus/onBlur bubble even though FormInputs doesn't forward these
  // as props). Blur hides it after a short delay rather than
  // immediately, so a click on the button itself (which briefly blurs
  // the field first) still has time to register before it disappears.
  const [isLastRowActive, setIsLastRowActive] = useState(false);
  const lastRowBlurTimeoutRef = useRef(null);
  const handleLastRowFocus = () => {
    if (lastRowBlurTimeoutRef.current) clearTimeout(lastRowBlurTimeoutRef.current);
    setIsLastRowActive(true);
  };
  const handleLastRowBlur = () => {
    lastRowBlurTimeoutRef.current = setTimeout(() => setIsLastRowActive(false), 200);
  };

  const handleRemoveInstallment = (key) => {
    setInstallments((prev) =>
      prev
        .filter((inst) => inst.key !== key)
        .map((inst, idx) => ({ ...inst, installment_no: idx + 1 }))
    );
  };

  const handleInstallmentField = (key, field, value) => {
    setInstallments((prev) =>
      prev.map((inst) => (inst.key === key ? { ...inst, [field]: value } : inst))
    );
  };

  // ---------------------------------------------------------------------
  // Reset / cancel
  // ---------------------------------------------------------------------
  const resetForm = () => {
    setSelectedStudent(null);
    setStudentProfile(null);
    setStudentPhotoUrl(null);
    setStudentOptions([]);
    setAccStudentId(null);
    setRegistrationFormNo("");
    setTotalFee("");
    setScholarship("");
    setDiscount("");
    setDefaultSgst("9");
    setDefaultCgst("9");
    setInstallments(
      Array.from({ length: DEFAULT_INSTALLMENT_COUNT }, (_, i) => makeInstallment(i + 1))
    );
    setApprovedBy("");
    setRemarks("");
    setShowError(false);
    setPristineSnapshot(null);
  };

  // True once the person has actually changed something from what was
  // loaded (or prefilled via URL) - used to decide whether Cancel needs
  // to confirm at all.
  const isFormDirty = () => {
    if (pristineSnapshot === null) return false;
    const currentSnapshot = JSON.stringify({
      totalFee: String(totalFee ?? ""),
      scholarship: String(scholarship ?? ""),
      discount: String(discount ?? ""),
      approvedBy: approvedBy || "",
      remarks: remarks || "",
      installments: installments.map((i) => ({
        due_date: i.due_date,
        amount: String(i.amount ?? ""),
        remarks: i.remarks || "",
      })),
    });
    return currentSnapshot !== pristineSnapshot;
  };

  const handleCancel = () => {
    if (!isFormDirty()) {
      navigate("/fee_plan_dashboard");
      return;
    }

    setShowCloseButton(false);
    setNoTimeSet(true); // keep the box open (it normally auto-closes after 3.5s) until Yes/No is clicked
    setIsMessageBoxVisible(true);
    setActiveImg(ErrorImg);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Are you sure you want to cancel? Unsaved changes will be lost.</span>
        </div>
        <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              setNoTimeSet(false);
              navigate("/fee_plan_dashboard");
            }}
          >
            Yes
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              setNoTimeSet(false);
            }}
          >
            No
          </button>
        </div>
      </div>
    );
  };

  // ---------------------------------------------------------------------
  // Submit
  // ---------------------------------------------------------------------
  const handleSubmit = async () => {
    setShowError(true);

    if (!selectedStudent) {
      notify("Please search and select a student.");
      return;
    }
    if (!selectedBatchType) {
      notify("Please select a Batch Type.");
      return;
    }
    if (!studentProfile?.course_id || !studentProfile?.session_id) {
      notify("Course/session details are unavailable for this student.");
      return;
    }
    if (!totalFee || Number(totalFee) <= 0) {
      notify("Please enter a valid Total Base Fee.");
      return;
    }
    if (!defaultSgst || !defaultCgst) {
      notify(
        "No SGST/CGST rate is configured for this course/session/branch/class combination - please contact your administrator to configure this."
      );
      return;
    }
    if (installments.length === 0) {
      notify("Please add at least one installment.");
      return;
    }
    for (const inst of installments) {
      if (!inst.due_date || !inst.amount || Number(inst.amount) <= 0) {
        notify("Please complete the due date and amount for every installment.");
        return;
      }
      if (computePercentage(inst.amount, netFeeBase) > 100) {
        notify(`Installment ${inst.installment_no}'s amount can't be more than the net fee (100%).`);
        return;
      }
      if (inst.due_date < todayStr()) {
        notify(
          `Installment ${inst.installment_no}'s due date can't be in the past - it must be today or later.`
        );
        return;
      }
      if (sessionEndDate && inst.due_date > sessionEndDate) {
        notify(
          `Installment ${inst.installment_no}'s due date can't be after the session's end date (${formatDisplayDate(sessionEndDate)}).`
        );
        return;
      }
    }
    for (let i = 1; i < installments.length; i++) {
      if (installments[i].due_date <= installments[i - 1].due_date) {
        notify(
          `Installment ${installments[i].installment_no}'s due date must be later than installment ${installments[i - 1].installment_no}'s due date.`
        );
        return;
      }
    }
    if (isConcessionApplied) {
      const missing = [];
      if (!approvedBy.trim()) missing.push("Approved By");
      if (!remarks.trim()) missing.push("Remarks");
      if (missing.length > 0) {
        notify(
          `${missing.join(" and ")} ${
            missing.length > 1 ? "are" : "is"
          } required when a scholarship or concession is applied.`
        );
        return;
      }
    }
    if (Math.abs(installmentTotals.instAmount - netFeeBase) > 1) {
      notify(
        `Installment amounts (₹ ${formatINR(
          installmentTotals.instAmount
        )}) do not add up to the Net Fee (₹ ${formatINR(
          netFeeBase
        )}). Please adjust the installment amount to match net fee.`
      );
      return;
    }
    if (!userName) {
      notify("Unable to determine the logged-in user. Please re-login and try again.");
      return;
    }

    // Only the fields expected by create-student-fee-plan are sent - the
    // percentage, rupee tax breakup, Total row, etc. are UI-only.
    const payload = {
      student_id: Number(selectedStudent.student_id),
      session_id: Number(studentProfile.session_id),
      course_id: Number(studentProfile.course_id),
      reg_form_no: registrationFormNo || null,
      total_fee_inr: Number(totalFee),
      scholarship_amount: Number(scholarship) || 0,
      discount_amount: Number(discount) || 0,
      net_fee: Number(netFee),
      sgst: sgstAmount,
      cgst: cgstAmount,
      remarks: remarks || null,
      approved_by: approvedBy || null,
      username: userName,
      fee_schedule_list: installments.map((inst) => {
        const instAmount = Number(inst.amount) || 0;
        const breakup = installmentTaxBreakup(instAmount, defaultSgst, defaultCgst);
        return {
          installment_no: inst.installment_no,
          due_date: inst.due_date,
          amount: Number(instAmount),
          sgst: breakup.sgst,
          cgst: breakup.cgst,
          remarks: inst.remarks || null,
        };
      }),
    };

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("other");
      const response = await fetch(EndPoints.CREATE_STUDENT_FEE_PLAN, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (data?.status === 200) {
        // Plan created - go straight back to the fee plan dashboard. The
        // message box lives in Landing, so the success message stays
        // visible over the dashboard; noTimeSet is reset so it auto-closes.
        setNoTimeSet && setNoTimeSet(false);
        notify(data.message || "Student fee plan created successfully.", false);
        resetForm();
        navigate("/fee_plan_dashboard");
      } else {
        notify(data?.message || "Failed to create student fee plan.");
      }
    } catch (err) {
      console.error("Error creating fee plan:", err);
      notify("An error occurred while creating the fee plan.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="nfp-container">
      <div className="nfp-interactive">
        {/* ---------------- Header (matches /testscheduling page header) ---------------- */}
        <div className="nfp-header-sticky">
          <div className="nfp-page-header">
            <div className="nfp-page-title">Fee Plan</div>
            <div className="nfp-header-btns">
              <button
                className="create-test-section-btn"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                CANCEL
              </button>
              <button
                className="create-test-section-btn"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "SAVING..." : "SAVE"}
              </button>
            </div>
          </div>
        </div>

        {/* ---------------- Student & Course Details ---------------- */}
        <div className="nfp-section">
          <SectionHeader
            title="STUDENT & COURSE DETAILS"
            isOpen={sectionOpen.student}
            onToggle={() => toggleSection("student")}
          />
          {sectionOpen.student && (
            <div className="Body-1-C424342 nfp-section-body">
              <div className="nfp-grid-3">
                {selectedStudent || studentProfile ? (
                  <FormInputs
                    label="Student"
                    disabled
                    value={
                      selectedStudent?.student_full_name ||
                      studentProfile?.student_full_name ||
                      ""
                    }
                  />
                ) : (
                  <div className="nfp-field">
                    <SearchDropdown
                      label="Student *"
                      placeholder="Search student"
                      initialOptions={studentOptions}
                      onInputChange={fetchStudents}
                      onSelect={handleSelectStudent}
                      selected={selectedStudent}
                      hasError={showError && !selectedStudent}
                      labelKey={(opt) =>
                        `${opt.student_full_name || ""} / ${opt.roll_number || ""} / ${
                          opt.batch_name || ""
                        }`
                      }
                    />
                  </div>
                )}
                <FormInputs
                  label="Roll No"
                  disabled
                  value={studentProfile?.Roll_Number || ""}
                />
                <FormInputs
                  label="Batch"
                  disabled
                  value={studentProfile?.Batch || ""}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <div className="formInput">
                  <label>
                    Batch Type
                    <span>*</span>
                  </label>
                  <DropDown
                    selected={selectedBatchType}
                    setSelected={handleBatchTypeChange}
                    options={batchTypes.map((bt) => ({
                      id: bt.batch_type_id,
                      label: bt.batch_type_desc,
                    }))}
                    placeholder={batchTypes.length === 0 ? "No batch types for this class" : "Select batch type"}
                    disabled={batchTypes.length <= 1}
                    Height="auto"
                    minheight="150px"
                    OverFlow="auto"
                  />
                </div>
                <FormInputs
                  label="Class"
                  disabled
                  value={studentProfile?.Class_name || ""}
                />
                <FormInputs
                  label="Course"
                  disabled
                  value={studentProfile?.Course_Name || ""}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Father/Mother/Guardian"
                  disabled
                  value={
                    studentProfile?.father_name ||
                    studentProfile?.mother_name ||
                    studentProfile?.guardian_name ||
                    ""
                  }
                />
                <FormInputs
                  label="Session"
                  disabled
                  value={studentProfile?.session || ""}
                />
                <FormInputs
                  label="Enquiry Date"
                  disabled
                  value={formatDisplayDate(studentProfile?.admission_date)}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Account Student ID"
                  disabled
                  value={accStudentId || ""}
                />
              </div>
            </div>
          )}
        </div>

        {/* ---------------- Fee Details ---------------- */}
        <div className="nfp-section">
          <SectionHeader
            title="FEE DETAILS"
            isOpen={sectionOpen.fee}
            onToggle={() => toggleSection("fee")}
          />
          {sectionOpen.fee && (
            <div className="Body-1-C424342 nfp-section-body">
              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Base Fee (₹)"
                  required
                  showError={showError}
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={totalFee}
                  disabled
                />
                <FormInputs
                  label="Scholarship (₹)"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={scholarship}
                  onChange={(e) => setScholarship(e.target.value)}
                />
                <FormInputs
                  label="Concession (₹)"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs label="Net Fee (₹)" value={`${formatINR(netFeeBase)}`} disabled />
                <FormInputs label="SGST (₹)" value={`${formatINR(sgstAmount)}`} disabled />
                <FormInputs label="CGST (₹)" value={`${formatINR(cgstAmount)}`} disabled />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Total Fees Payable (₹)"
                  value={`${formatINR(netFee)}`}
                  disabled
                />
                <FormInputs
                  label="Approved By"
                  placeholder="Name of approving authority"
                  value={approvedBy}
                  maxLength={10}
                  onChange={(e) => setApprovedBy(e.target.value)}
                  required={isConcessionApplied}
                  showError={showError}
                />
                <FormInputs
                  label="Remarks"
                  placeholder="Add any notes regarding this fee plan..."
                  value={remarks}
                  maxLength={500}
                  onChange={(e) => setRemarks(e.target.value)}
                  required={isConcessionApplied}
                  showError={showError}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Registration Form No."
                  placeholder="Enter registration form number"
                  value={registrationFormNo}
                  maxLength={10}
                  onChange={(e) => setRegistrationFormNo(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>

        {/* ---------------- Installment Schedule ---------------- */}
        <div className="nfp-section">
          <div className="Header-1-C424342 nfp-section-header">
            <span>INSTALLMENT SCHEDULE</span>
            {sectionOpen.installments ? (
              <img
                src={MinusImg}
                alt="Toggle"
                className="nfp-toggle-icon"
                onClick={() => toggleSection("installments")}
              />
            ) : (
              <div
                className="plus nfp-toggle-plus"
                onClick={() => toggleSection("installments")}
              >
                +
              </div>
            )}
          </div>

          {sectionOpen.installments && (
            <div className="Body-1-C424342 nfp-section-body nfp-section-body-flush">
              <div className="nfp-table-wrap">
                <table className="nfp-table">
                  <thead>
                    <tr>
                      <th style={{ width: "48px" }}></th>
                      <th style={{ width: "60px" }}>Inst. No</th>
                      <th>Due Date</th>
                      <th>Inst Amount (₹)</th>
                      <th>Percentage (%)</th>
                      <th>SGST (₹)</th>
                      <th>CGST (₹)</th>
                      <th>Total GST (₹)</th>
                      <th>Gross Inst Amount (₹)</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {installments.map((inst, idx) => {
                      const instAmount = Number(inst.amount) || 0;
                      const breakup = installmentTaxBreakup(
                        instAmount,
                        defaultSgst,
                        defaultCgst
                      );
                      const isLastRow = idx === installments.length - 1;
                      const previousDueDate = idx > 0 ? installments[idx - 1].due_date : null;
                      const minDueDate =
                        previousDueDate && nextDayStr(previousDueDate) > todayStr()
                          ? nextDayStr(previousDueDate)
                          : todayStr();
                      return (
                        <tr
                          key={inst.key}
                          onFocus={isLastRow ? handleLastRowFocus : undefined}
                          onBlur={isLastRow ? handleLastRowBlur : undefined}
                        >
                          <td className="nfp-row-remove">
                            <div className="nfp-row-remove-spacer"></div>
                            {installments.length > 1 && (
                              <span
                                className="nfp-remove-btn"
                                onClick={() => handleRemoveInstallment(inst.key)}
                                title="Remove installment"
                              >
                                ×
                              </span>
                            )}
                          </td>
                          <td className="nfp-inst-no">{inst.installment_no}</td>
                          <td>
                            <FormDateInput
                              label=""
                              required
                              showError={showError}
                              min={minDueDate}
                              max={sessionEndDate || maxDueDateStr()}
                              value={inst.due_date}
                              onChange={(e) =>
                                handleInstallmentField(inst.key, "due_date", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              type="number"
                              required
                              showError={showError}
                              min="0"
                              step="0.01"
                              placeholder="0"
                              value={inst.amount}
                              onChange={(e) =>
                                handleInstallmentField(inst.key, "amount", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              value={`${computePercentage(inst.amount, netFeeBase).toFixed(2)}`}
                              disabled
                            />
                          </td>
                          <td>
                            <FormInputs label="" value={`${formatINR(breakup.sgst)}`} disabled />
                          </td>
                          <td>
                            <FormInputs label="" value={`${formatINR(breakup.cgst)}`} disabled />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              value={`${formatINR(breakup.totalGst)}`}
                              disabled
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              value={`${formatINR(breakup.grossAmount)}`}
                              disabled
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              placeholder="Optional"
                              value={inst.remarks}
                              className="nfp-remarks-input"
                              onChange={(e) =>
                                handleInstallmentField(inst.key, "remarks", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                    {isLastRowActive && (
                      <tr className="nfp-add-installment-row-inline">
                        <td colSpan={9}></td>
                        <td style={{ textAlign: "right" }}>
                          <img
                            src={YellowPlus}
                            alt="Add installment"
                            className="nfp-add-icon"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={handleAddInstallment}
                            title="Add installment"
                          />
                        </td>
                      </tr>
                    )}
                    {/* UI-only summary row - not part of fee_schedule_list */}
                    <tr className="nfp-total-row">
                      <td></td>
                      <td colSpan={2}>Total</td>
                      <td>₹ {formatINR(installmentTotals.instAmount)}</td>
                      <td></td>
                      <td>₹ {formatINR(installmentTotals.sgst)}</td>
                      <td>₹ {formatINR(installmentTotals.cgst)}</td>
                      <td>₹ {formatINR(installmentTotals.totalGst)}</td>
                      <td>₹ {formatINR(installmentTotals.grossAmount)}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="nfp-installment-total-row">
                <span>Net Fee Payable: ₹ {formatINR(netFee)}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewFeePlan;